import _Vue from 'vue'
import { Store } from './store'
import settings from '@dinosband/bv-settings'

interface BvMainClientPluginOptions {
  httpURI: string
  wsURI: string
  restURI: string
}

export let mainStore: Store = new Store(settings, '', '', '') // empty store

function install (Vue: typeof _Vue, options: BvMainClientPluginOptions): void {
  const store = new Store(settings, options.httpURI, options.wsURI, options.restURI)

  mainStore = Vue.observable(store)
  Vue.prototype.$mainStore = mainStore
}

export const BvMainClientPlugin = {
  install,
  version: '__VERSION__',
}

declare module 'vue/types/vue' {
  interface Vue {
    $mainStore: Store
  }
}